'use client'

import { AcceptInviteForm } from '../AcceptInvite/Form'

import { Card, CardHeader, CardTitle, CardBody } from '@/shared/ui/Card'

export function AcceptInvitePage() {
  return (
    <Card className="max-w-md">
      <CardHeader>
        <CardTitle>Aceitar convite</CardTitle>
      </CardHeader>
      <CardBody className="text-dark">
        <AcceptInviteForm />
      </CardBody>
    </Card>
  )
}
